class ProductMediaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (!this.els.slide || this.els.slide.elements.length < 2) return

    this.startY = 0
    this.setupCheck()
    this.setImageHeight()
    this.initialAnimation()
  }

  setupListeners () {
    window.addEventListener('resize', this.onResize.bind(this))
    document.addEventListener('variantChange', this.OnVariantChange.bind(this))

    this.els?.dot?.elements.forEach(dot => {
      dot.addEventListener('click', this.onDotClick.bind(this))
    })
  }

  initialAnimation () {
    const hasCarousel = this.carousel != null

    if (hasCarousel) {
      const slides = Array.from(this.els.slide.elements).filter(slide => slide.getAttribute('aria-hidden') !== 'true')

      if (slides.length >= 2) {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              const allStyled = Array.from(slides).every(slide => slide.hasAttribute('style'))
              if (allStyled) {
                observer.disconnect()
                animateSlides()
              }
            }
          })
        })

        slides.forEach(slide => {
          observer.observe(slide, { attributes: true })
        })

        const animateSlides = () => {
          setTimeout(() => {
            slides.forEach(slide => {
              slide.style.transform = 'translate3d(-150px, 0, 0)'
              slide.style.transition = 'transform 0.5s ease'

              setTimeout(() => {
                slide.style.transform = 'translate3d(0, 0, 0)'
                slide.style.transition = 'transform 0.5s ease'

                setTimeout(() => {
                  slide.style.transition = ''
                }, 500)
              }, 500)
            })
          }, 1000)
        }
      }
    }
  }

  onResize () {
    this.setImageHeight()
    this.setupCheck()
  }

  OnVariantChange () {
    this.setupCheck()
  }

  setupCheck () {
    this.mobileHorizontal = this.dataset?.galleryOptions === 'horizontal'

    const hasCarousel = this.carousel != null

    if (hasCarousel) {
      this.carousel.destroy()
      this.carousel = null
    }

      this.updateFirstActiveDot()
      this.carousel = this.setupCarousel()
      this.setupLastSlideDrag()
    
  }

  setImageHeight () {
    const shownSlide = this.els.slide.elements.find((element) => element.ariaHidden === null)
    if (shownSlide?.offsetHeight > 0) {
      document.body.style.setProperty('--first_image_height', `${shownSlide?.offsetHeight}px`)
    }
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1,
        },
        slideChanged: (instance) => this.onSlideChanged(instance),
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  setupLastSlideDrag () {
    if (this.mobileHorizontal) return
    const slidesArr = document.querySelectorAll(`${this.els.slide.selector}:not([aria-hidden='true'])`)
    const lastSlide = slidesArr[slidesArr.length - 1]

    let dragging = false

    const handleStart = (e) => {
      dragging = true
      this.startY = e.touches ? e.touches[0].clientY : e.clientY
    }

    const handleMove = (e) => {
      if (!dragging) return

      const currentY = e.touches ? e.touches[0].clientY : e.clientY
      if (this.startY > currentY) {
        this.onDragUp()
        dragging = false // Reset the flag to prevent multiple triggers in the same drag session
      }
    }

    const handleEnd = () => {
      dragging = false // Reset the flag when the drag ends
    }

    lastSlide.addEventListener('touchstart', handleStart)
    lastSlide.addEventListener('mousedown', handleStart)

    lastSlide.addEventListener('touchmove', handleMove)
    lastSlide.addEventListener('mousemove', handleMove)

    lastSlide.addEventListener('touchend', handleEnd)
    lastSlide.addEventListener('mouseup', handleEnd)
    lastSlide.addEventListener('mouseleave', handleEnd)
  }

  onDragUp () {
    const rect = this.externalEls.main.element.getBoundingClientRect()
    const offsetTop = rect.top + window.pageYOffset
    window.scrollTo({ top: offsetTop, behavior: 'smooth' })
  }

  onSlideChanged (instance) {
    const slide = instance.slides[instance.track.details.abs]
    this.updateActiveDot(slide.id)
  }

  updateFirstActiveDot () {
    this.els?.dot?.elements.forEach(dot => {
        dot.removeAttribute('aria-active')
    })

    const firstDot = document.querySelector(`${this.els.dot.selector}:not([aria-hidden='true'])`)
    firstDot.setAttribute('aria-active', 'true')
  }

  updateActiveDot (activeId) {
    this.els?.dot?.elements.forEach(dot => {
      if (!dot.getAttribute('aria-hidden') || dot.getAttribute('aria-hidden') !== 'true') {
        if (dot.getAttribute('href') === `#${activeId}`) {
          dot.setAttribute('aria-active', 'true')
        } else {
          dot.removeAttribute('aria-active')
        }
      }
    })
  }

  onDotClick (e) {
    e.preventDefault()

    this.els.dot.elements.forEach(dot => {
      dot.removeAttribute('aria-active')
    })

    const target = e.target
    target.setAttribute('aria-active', 'true')

    const productId = target.href.split('#')[1]

    // Get all visible slides
    const visibleSlides = Array.from(document.querySelectorAll('.prd-Media_Slide:not([aria-hidden="true"])'))

    // Find the index of the slide that matches the productId
    const targetSlideIndex = visibleSlides.findIndex(slide => slide.id === productId)

    // Move to the found index if it's valid
    if (targetSlideIndex !== -1) {
      this.carousel.moveToIdx(targetSlideIndex)
    }
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMediaCarousel)
}
